function hideFirstProductCard() {
    if (window.innerWidth >= 768) { 
      let firstCard = document.querySelector('#AjaxinateLoop .product-collection-first-product:first-child');
      if (firstCard) {
        firstCard.classList.add('hidden');
      }
    }
  }
  
  document.addEventListener("DOMContentLoaded", function() {
    hideFirstProductCard();
  });
  